export const getIcon = (
  key: string,
  category: string,
  notFoundIcon: string
): string => {
  let imgSrc = null;

  try {
    const module = require(`../../../../assets/icons/${category}/${key}.svg`);
    // Access .default property to get the actual path
    imgSrc = module.default || module;
  } catch (e: any) {
    //@ts-ignore
    imgSrc = notFoundIcon;
  }
  return imgSrc;
};
